import { ITradeNameByStoreDTO, ITradeNameDTO, ITradeNameViewDTO } from "../../libs/coreapi-dto/dirs/tradeName";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class TradeNameDataProvider extends DictionaryDataProvider<ITradeNameViewDTO, ITradeNameDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ITradeNameViewDTO, ITradeNameDTO>> {
        return this._coreApiService.tradeNameRequest
    }

    getDistinctViewByStore(filter: IViewBody, callback?: (data: ITradeNameByStoreDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
            this._coreApiService.tradeNameRequest
                .then(r => r
                    .getDistinctViewByStore(filter, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e.data.entities, e.data.totalCount);
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        else
                            throw new Error(e?.message.title ?? 'DictionaryDataProvider getDistinctViewByStore !isCompleted');
                    },signal)
                )
                .catch((e) => {
                    throw new Error(e?.message.text ?? 'getDistinctViewByStore DictionaryDataProvider')
                });
        }
}